<footer class="main-footer">
    <i><b>Copyright</b> © 2023-2024 persona service AG & Co. KG.</i>
    <div class="float-right d-none d-sm-inline-block">
        <b>Version</b> 1.4.0 / M&auml;rz 2024
    </div>
</footer>
